<div class="At-NotificationsPage">
  <div class="At-PageHeading">
    <h2>Notifications</h2>
  </div>
  <div class="At-NotificationsContent">
    <div class="At-InformationBox">
      <div class="At-Title">
        <h3>New</h3>
      </div>
      <ul class="At-InformationList">
        <li>
          <div class="At-InfoBox">
            <div class="At-InfoImg">
              <figure><img src="assets/images/members/member-img09.png" alt="" class="img-fluid"></figure>
            </div>
            <div class="At-InfoTitle d-flex">
              <div class="At-TitleLeft">
                <h5>Aiman <span class="At-TextDarkGrey2">posted a new photo </span></h5>
                  <h6>6 hours ago</h6>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div class="At-InfoBox">
            <div class="At-InfoImg">
              <figure>
                <img src="assets/images/members/member-img01.png" alt="" class="img-fluid">
                <div class="At-badgePurple"><i class="icon-bage"></i></div>
              </figure>
            </div>
            <div class="At-InfoTitle d-flex">
              <div class="At-TitleLeft">
                <h5>Julian <span class="At-TextDarkGrey2">invited you to join channel <strong>“Software Development Team”</strong></span></h5>
                  <h6>14 hours ago</h6>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div class="At-InfoBox">
            <div class="At-InfoImg">
              <figure><img src="assets/images/profile/profile-small3.png" alt="" class="img-fluid"></figure>
            </div>
            <div class="At-InfoTitle d-flex">
              <div class="At-TitleLeft">
                <h5>Ainita <span class="At-TextDarkGrey2">send you a follow request</span></h5>
                  <h6>14 hours ago</h6>
              </div>
              <div class="At-BtnArea">
                <Button class="mr-4">Accept</Button>
                <Button class="At-BgRed">Decline</Button>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="At-InformationBox">
      <div class="At-Title">
        <h3>Others</h3>
      </div>
      <ul class="At-InformationList">
        <li>
          <div class="At-InfoBox">
            <div class="At-InfoImg">
              <figure><img src="assets/images/members/member-img03.png" alt="" class="img-fluid"></figure>
            </div>
            <div class="At-InfoTitle d-flex">
              <div class="At-TitleLeft">
                <h5>Jacob <span class="At-TextDarkGrey2">commented on your post “It feels like just yesterday that we have met  :( ” </span></h5>
                  <h6>22 hours ago</h6>
              </div>
              <div class="At-TitleRight">
                <div class="At-InfoImg">
                  <figure><img src="assets/images/posts/post-img7.png" alt="" class="img-fluid"></figure>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div class="At-InfoBox">
            <div class="At-InfoImg">
              <figure>
                <img src="assets/images/members/member-img05.png" alt="" class="img-fluid">
                <div class="At-badgePurple"><i class="icon-bage"></i></div>
              </figure>
            </div>
            <div class="At-InfoTitle d-flex">
              <div class="At-TitleLeft">
                <h5>Anatoli <span class="At-TextDarkGrey2">accepted your follow request</span></h5>
                  <h6>1 day ago</h6>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div class="At-InfoBox">
            <div class="At-InfoImg">
              <figure><img src="assets/images/members/member-img02.png" alt="" class="img-fluid"></figure>
            </div>
            <div class="At-InfoTitle d-flex">
              <div class="At-TitleLeft">
                <h5>Micheal <span class="At-TextDarkGrey2">commented on your post “Don’t forget to bring a hoodie for me ”</span></h5>
                  <h6>1 day ago</h6>
              </div>
              <div class="At-TitleRight">
                <div class="At-InfoImg">
                  <figure><img src="assets/images/posts/post-img8.png" alt="" class="img-fluid"></figure>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div class="At-InfoBox">
            <div class="At-InfoImg">
              <figure><img src="assets/images/members/member-img10.png" alt="" class="img-fluid"></figure>
            </div>
            <div class="At-InfoTitle d-flex">
              <div class="At-TitleLeft">
                <h5>Jacob <span class="At-TextDarkGrey2">and 2 others liked your post</span></h5>
                  <h6>1 day ago</h6>
              </div>
              <div class="At-TitleRight">
                <div class="At-InfoImg">
                  <figure><img src="assets/images/posts/post-img9.png" alt="" class="img-fluid"></figure>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div class="At-InfoBox">
            <div class="At-InfoImg">
              <figure><img src="assets/images/members/member-img04.png" alt="" class="img-fluid"></figure>
            </div>
            <div class="At-InfoTitle d-flex">
              <div class="At-TitleLeft">
                <h5>Softpetal:) <span class="At-TextDarkGrey2">liked your comment “The place looks beautiful:) ”</span></h5>
                  <h6>1 day ago</h6>
              </div>
              <div class="At-TitleRight">
                <div class="At-InfoImg">
                  <figure><img src="assets/images/posts/post-img10.png" alt="" class="img-fluid"></figure>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div class="At-InfoBox">
            <div class="At-InfoImg">
              <figure><img src="assets/images/profile/profile-small5.png" alt="" class="img-fluid"></figure>
            </div>
            <div class="At-InfoTitle d-flex">
              <div class="At-TitleLeft">
                <h5>Manuel <span class="At-TextDarkGrey2">send you a follow request</span></h5>
                  <h6>1 day ago</h6>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
